export default __webpack_public_path__ + "static/media/about us page_Centricity.241de4c7.png";